module.exports = __webpack_public_path__ + "img/logo.e31cce0c.svg";